export default {"src":"/_next/static/media/arrow_right_gray.e8a088cf.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};